<template>
  <div
    class="relative w-full h-screen flex items-center justify-center bg-cover bg-center px-10"
    :style="{ backgroundImage: `url(${BackgroundImage})` }"
  >
    <div class="p-10 bg-white flex flex-col max-w-3xl text-center rounded shadow-2xl sm:min-w-3xl">
      <img src="@/assets/images/logo.svg" class="max-w-xs mx-auto mb-10" />
      <div>
        <h1 class="text-3xl font-medium mb-2">Page not found.</h1>
        <h2 class="text-xl mx-auto">The page you are looking for cannot be found.</h2>
        <button class="btn btn-action btn-lg mt-5" @click="redirect">Back To Home</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/pinia/auth'
import { useBrandedStore } from '@/pinia/branded'
import BackgroundImage from '@/assets/images/login-background.png'

export default {
  computed: {
    ...mapStores(useAuthStore, useBrandedStore)
  },
  setup() {
    return { BackgroundImage }
  },
  methods: {
    redirect() {
      if (this.authStore.installation === 'branded') {
        this.$router.replace(this.brandedStore.launchURL).catch(() => {})
      } else {
        this.$router.replace('/').catch(() => {})
      }
    }
  }
}
</script>
